import AppConfig from "../config/AppConfig";
import { Configuration, LogLevel  } from "@azure/msal-browser";

// MSAL configuration
const AuthConfig: Configuration = {
    auth: {
        clientId: AppConfig().ClientId!,
        authority: `https://login.microsoftonline.com/${AppConfig().TenantId!}`,
        redirectUri: "/", //window.location.href
        postLogoutRedirectUri: '/' ,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
        secureCookies: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false
        },
    }
};


// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {            
    scopes: ["User.Read"]
}

//api://1d2c1bee-a383-4590-83e5-4d375b252686/IDP.Admin
//api://1d2c1bee-a383-4590-83e5-4d375b252686/IDP.Users

// Add scope for custom API - use this scopes to get Access token from AD to sent with API header
// update - RequestInterceptor component - change loginRequest to this scope
export const ApiAdminScope = {
    scopes: [AppConfig().ApiAdminScope]
}

export const ApiUserScope = {
    scopes: [AppConfig().ApiUserScope]
}

// Add the endpoints here for Microsoft Graph API.
export const graphConfig = {
    graphMeEndpoint: `${AppConfig().GraphApi}/v1.0/me`
};

export default AuthConfig;